export enum ELocale {
  IT = 'it',
  EN = 'en'
}
